import { render, staticRenderFns } from "./ConfigurationFormFile.vue?vue&type=template&id=0ec49d15&scoped=true&"
import script from "./ConfigurationFormFile.vue?vue&type=script&lang=js&"
export * from "./ConfigurationFormFile.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationFormFile.vue?vue&type=style&index=0&id=0ec49d15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec49d15",
  null
  
)

export default component.exports